import { render, staticRenderFns } from "./PlaceSameSettingModal.vue?vue&type=template&id=46ccc163&"
import script from "./PlaceSameSettingModal.vue?vue&type=script&lang=js&"
export * from "./PlaceSameSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports